import React from 'react';
import SidebarWorkspaceSwitcher from './SidebarWorkspaceSwitcher';

/**
 * Sidebar identity: Fokus mark + stacked app name / current brain.
 * Collapse, back/forward, and Brain live on the navbar / footer.
 */
const SidebarHeader = ({
  appName = 'Fokus',
  workspaceId,
  workspaces,
  setWorkspace,
  onOpenSettings,
}) => {
  return (
    <div className="sidebar__header">
      <div className="sidebar__identity">
        <a href="/" className="sidebar__brand-mark" title="Fokus" aria-label="Fokus">
          <svg
            className="sidebar__brand-icon"
            viewBox="0 0 382 402"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path d="M264.682 99.3255C329.545 99.7438 382 153.418 382 218.417C382 279.377 335.862 330.375 276.621 336.823V278.693C303.682 272.706 324.606 248.048 324.606 218.417C324.606 184.286 296.845 156.752 263.919 156.752H57.3941V219.358C57.3941 248.703 78.1961 273.185 105.85 278.848V336.884C46.6306 330.785 0.386915 280.898 0.00229709 220.122L0 219.358V99.3232H263.919L264.682 99.3255Z" fill="white"/>
            <path d="M219.697 402H162.773V199.117H219.697V402Z" fill="white"/>
            <path d="M219.697 56.9578H162.773V0H219.697V56.9578Z" fill="white"/>
          </svg>
        </a>
        <div className="sidebar__identity-copy">
          <a href="/" className="sidebar__brand-text">{appName}</a>
          <SidebarWorkspaceSwitcher
            embedded
            workspaceId={workspaceId}
            workspaces={workspaces}
            setWorkspace={setWorkspace}
            onOpenSettings={onOpenSettings}
          />
        </div>
      </div>
    </div>
  );
};

export default SidebarHeader;
